<template>
  <div class="loginWrapper">
    <div class="leftBox">
      <img class="bgImage" :src="bgImage">
      <img class="bannerimg" :src="bannerimg">
    </div>
    <div class="rightBox">
      <div class="headerBox">
        <div class="leftHeader">
          <div class="iconBox rflex jcsa">
            <img class="logoIcon" :src="logoIcon">
            <div>
              <div class="bold">欢迎登陆店长助手</div>
              <div class="grey">欢迎回来</div>
            </div>
          </div>
        </div>
        <div class="loginBox">
          <div class="tabBox">
            <div class="tabItem">
              账号密码登录
            </div>
          </div>
          <el-form :model="form" ref="form" :rules="rules" hide-required-asterisk>
            <el-form-item prop="tenant">
              <template #label>
                <div class="grey">企业代码</div>
              </template>
              <el-input v-model="form.tenant" placeholder="请输入企业代码"></el-input>
            </el-form-item>
            <el-form-item prop="account">
              <template #label>
                <div class="grey">账号</div>
              </template>
              <el-input v-model="form.account" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <template #label>
                <div class="grey">密码</div>
              </template>
              <el-input v-model="form.password" show-password placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-checkbox v-model="savePW">记住密码</el-checkbox>
            <div class="text_center">
              <el-button type="primary" class="subBtn" round @click="goLogin">登 录</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { login } from '@/api/request'
export default {
  data() {
    return {
      form: {
        account: "",
        tenant: "",
        password: "",
        browserInfo:''
      },
      savePW: false,
      logoIcon: require("@/assets/image/LOGO.png"),
      bgImage: require("@/assets/image/bg.png"),
      bgLoginLeft: require("@/assets/image/bg_login_left.png"),
      bannerimg: require("@/assets/image/bannerimg.png"),
      rules: {
        tenant: [
          { required: true, message: '请输入企业代码', trigger: 'blur' },
        ],
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      }
    }
  },
  created() {
    this.form.browserInfo = navigator.appVersion
    let loginInfo = JSON.parse(window.localStorage.getItem("loginInfo"));
    if (loginInfo) {
      this.form.account = loginInfo.account
      this.form.tenant = loginInfo.tenant
      this.form.password = loginInfo.password
      this.savePW = loginInfo.savePW;
    }
  },
  methods: {
    goLogin() {
      this.$refs.form.validate(valid => {
        if (valid) {
          login(this.form).then(res=>{
            if(res.success){
              if(!res.data.pcMenus.length && !res.data.trainingModuleEnable) {
                this.$message.error('您没有任何权限！请先联系管理员！！！');
                return
              }
              window.sessionStorage.setItem("userInfo", JSON.stringify(res.data))
              this.$store.dispatch('getDynamicMenuRoutes', res.data)
              this.$store.state.permission.addRouters.forEach(r => this.$router.addRouteNotAdded(r))
              this.$router.push('/'+this.$store.state.permission.defaultRoute)
              if (this.savePW) {
                window.localStorage.setItem("loginInfo", JSON.stringify(Object.assign(this.form,{savePW:this.savePW})));
              } else {
                window.localStorage.removeItem("loginInfo");
              }
            }
          })
        }else {
          return false
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
  .loginWrapper{
    display: flex;
    flex-flow: row nowrap;
    height: 100%;
    width: 100%;
    min-width: 1280px;
    .bgImage{
      height: 100%;
      width: 100%;
       min-height: 641px;
    }
    .bold{
      font-weight: 500;
    }
    .grey{
      color: #606266;
    }
    .leftBox{
      flex: 1;
      position: relative;
    }
    .bannerimg{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: block;
      margin: auto;
      width: 90%;
    }
    // /deep/ .el-form-item{
    //   margin-bottom: 10px;
    // }
    .rightBox{
      width: 400px;
      height: 100%;
      .leftHeader{
        padding: 40px;
        height: 120px;
        background: #F8F9FC;
        .iconBox{
          width: 200px;
          line-height: 24px;
        }
      }
      .logoIcon{
        width: 48px;
        height: 48px;
      }
    }
    .loginBox{
      position: relative;
      margin: 40px;
    }
    .subBtn{
      width: 320px;
      margin-top: 28px;
    }
    .tabBox{
      position: absolute;
      top: -60px;
      left: 0;
      height: 60px;
      width: 400px;
      margin-left: -40px;
      background:  no-repeat url("../../assets/image/bg_login_left.png");
      background-size:  100% 100%;
      text-align: center;
      line-height: 60px;
      .tabItem{
        width: 180px;
        margin-left: 20px;
      }
    }
  }
</style>
